import { getMonth, getYear } from 'date-fns'

import { YEAR_MONTHS } from '../../../constants/date'
import { createDate } from '../../../utils/date'
import { divMod } from '../../../utils/number'

export function toMonths(date) {
  return date == null ? null : getYear(date) * YEAR_MONTHS + getMonth(date)
}

export function fromMonths(timeZone, months) {
  const [year, month] = divMod(months, YEAR_MONTHS)

  return createDate(timeZone, year, month)
}
